import {qspost} from '@/plugins/axios'



/*
 * 用户列表
 * */
export const getUserList = (keyword,xiangmu_id, page, pageSize) => qspost('/index/gzhuser/userList', {
  keyword,xiangmu_id, page, pageSize
})


/*
 * 锁定/解锁用户
 * */
export const setGoodLock = (id) => qspost('/index/gzhuser/lockUser', {
  id
})

/*
 * 删除用户
 * */
export const delUser = (id) => qspost('/index/gzhuser/delUser', {
  id
})

/*
 * 用户积分记录
 * */
export const getPointsLogs = (keyword,id, page, pageSize) => qspost('index/gzhuser/pointsLog', {
  keyword,id, page, pageSize
})

/*
 * 积分商品列表
 * */
export const getGoodList = (keyword,xiangmu_id, page, pageSize) => qspost('/index/gzhgood/goodList', {
  keyword,xiangmu_id, page, pageSize
})

/*
 * 积分商品详情
 * */
export const getGoodDetail = (id) => qspost('/index/gzhgood/goodDetail', {
  id
})

/*
 * 上下架商品
 * */
export const setGoodShow = (id) => qspost('/index/gzhgood/goodIsShow', {
  id
})

/*
 * 删除积分商品
 * */
export const delGood = (id) => qspost('/index/gzhgood/delGood', {
  id
})

/*
 * 商品添加
 * */
export const addGood = (xiangmu_id, name, price, num, images, content, id = '') => qspost('/index/gzhgood/goodSave', {
  xiangmu_id, name, price, num, images, content, id
})
/*
 * 全部积分商品
 * */
export const getAllGood = () => qspost('/index/gzhgood/allGood', {})

/*
 * 积分商品兑换列表
 * */
export const getGoodOrderList = (keyword,good_id,xiangmu_id,state, page, pageSize) => qspost('/index/gzhgood/goodOrderList', {
    keyword,good_id,xiangmu_id,state, page, pageSize
})


/*
 * 通过兑换
 * */
export const passOrder = (id) => qspost('/index/gzhgood/passOrder', {
  id
})
/*
 * 拒绝兑换
 * */
export const refuseOrder = (id) => qspost('/index/gzhgood/cancelOrder', {
  id
})


/*
 * 活动列表
 * */
export const getActiveList = (keyword,xiangmu_id, page, pageSize) => qspost('/index/gzhactivity/activityList', {
  keyword,xiangmu_id, page, pageSize
})

/*
 * 活动详情
 * */
export const getActiveDetail = (id) => qspost('/index/gzhactivity/activityDetail', {
  id
})

/*
 * 删除活动
 * */
export const delActive = (id) => qspost('/index/gzhactivity/delActivity', {
  id
})

/*
 * 活动添加
 * */
export const addActive = (xiangmu_id, name, time, address,number,points, type, content, id = '') => qspost('/index/gzhactivity/activitySave', {
  xiangmu_id, name, time, address,number,points, type, content, id
})
/*
 * 全部活动
 * */
export const getAllActive = () => qspost('/index/gzhactivity/allActivity', {})

/*
 * 活动报名列表
 * */
export const getActiveSignList = (keyword,activity_id,xiangmu_id,state, page, pageSize) => qspost('/index/gzhactivity/activitySignList', {
  keyword,activity_id,xiangmu_id,state, page, pageSize
})

/*
 * 审核报名（发放积分）
 * */
export const passSign = (id,state) => qspost('/index/gzhactivity/passSign', {
  id,state
})
/*
 * 取消报名
 * */
export const cancelSign = (id) => qspost('/index/gzhactivity/cancelSign', {
  id
})
